export default __webpack_public_path__ + "static/media/einsparpotential-analyse.4fa3a756.webp";